<div style="margin: 20px">
  <app-recipes-form-header
    [recipeOriginal]="recipeOriginal"
    [typeAbaque]="typeAbaque"
    [formRecipe]="formRecipe"
    [variants]="variants$ | async"
    [isSeoURLDisabled$]="isSeoURLDisabled$"
    [applianceGroupsRefData]="applianceGroupsRefData$ | async"
    [variantDirty]="variantDirty"
    (updateRecipe)="updateRecipe.emit($event)"
  ></app-recipes-form-header>
  <app-recipes-form-body
    [recipeOriginal]="recipeOriginal"
    [variants]="variants$ | async"
    [yieldUnits]="yieldUnits"
    [statusesRefData]="statusesRefData$ | async"
    [applianceGroupsRefData]="applianceGroupsRefData$ | async"
    [utensilsRefData]="utensilsRefData$ | async"
    (shouldReloadVariantsInfo)="triggerReloadVariants$.next()"
    (variantDirty)="variantDirty = $event"
    (updateRecipe)="updateRecipe.emit($event)"
  ></app-recipes-form-body>
</div>
